
export const firebaseConfig = {
  apiKey: "AIzaSyDOky2DqLJdDF2AOTZ9QW1HaFk3YayVcD0",
  authDomain: "yamanashi2023db.firebaseapp.com",
  projectId: "yamanashi2023db",
  storageBucket: "yamanashi2023db.appspot.com",
  messagingSenderId: "353819969540",
  appId: "1:353819969540:web:a5671ebc980e8a86858d51",
  measurementId: "G-18DWWXNYM5"
}



// WEBPACK FOOTER //
// ./src/config.js